<template>
  <!--合同状态-->
  <el-select v-model="contractStatusCode" clearable>
    <el-option
      v-for="item in contractStatusList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!----------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-contractStatus",
    data() {
      return {
        contractStatusList: [],
        contractStatusCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'CONTRACT_STATUS',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.contractStatusList = res.data
        }
      })
    },
    watch: {
      contractStatusCode: function (currentVal) {
        this.$emit('contractStatusInfo', {contractStatusCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
